import React from 'react'
import './Home.scss'

export default function Home () {
  return (
    <div id='home'>
      {/* Banner removed as requested */}
    </div>
  )
}
